import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    GetAddress,
    OpenDialogCreateAddress,
    OpenDialogEditAddress,
    OpenDialogConfirmDeleteAddress,
    SetAddresAsDefault,
    GetTaxAddress,
    OpenDialogCreateTaxAddress,
    OpenDialogEditTaxAddress,
    OpenDialogConfirmDeleteTaxAddress,
    SetTaxAddressAsDefault
} from '../../../store/actions';
import UserTitle from '../components/user.title';
import UserSideMenu from '../components/user.side-menu';
import NotHaveShippingAddress from './components/shipping';
import NotHaveTaxInvoiceAddress from './components/taxinvoice';
import DialogCreateAddress from '../../Address/address.dialog-create';
import DialogEditAddress from '../../Address/address.dialog-edit';
import DialogConfirmDeleteAddress from '../../Address/address.dialog-confirm-delete';
import DialogNotAllowDeleteAddress from '../../Address/address.dialog-not-allow-delete';
import DialogCreateTaxAddress from '../../Address/tax-address.dialog-create';
import DialogEditTaxAddress from '../../Address/tax-address.dialog-edit';
import DialogConfirmDeleteTaxAddress from '../../Address/tax-address.dialog-confirm-delete';
import DialogNotAllowDeleteTaxAddress from '../../Address/tax-address.dialog-not-allow-delete';
import LayoutPreload from '../../Preload/layout.preload';
import _ from 'lodash';
import './address.css';
import hideTaxId from '../../../utils/hideData';

export default function UserAddressMain() {
    const dispatch = useDispatch();

    const wording = useSelector(({ language }) => language.wording);
    const shippingAddress = useSelector(({ address }) => address.data);
    const shippingAddressFetching = useSelector(({ address }) => address.isFetching);
    const taxInvoiceAddress = useSelector(({ taxaddress }) => taxaddress.data);
    const taxInvoiceAddressFetching = useSelector(({ taxaddress }) => taxaddress.isFetching);
    const firebaseAuth = useSelector(({ login }) => login.firebaseAuth);

    const shipping = 'shipping';
    const taxinvoice = 'taxinvoice';
    const [addressTypeSelected, SetAddressTypeSelected] = useState(shipping);

    useEffect(() => {
        if (firebaseAuth) {
            dispatch(GetAddress());
        }
    }, [firebaseAuth]);

    useEffect(() => {
        if (addressTypeSelected === shipping) {
            dispatch(GetAddress());
        }

        if (addressTypeSelected === taxinvoice) {
            dispatch(GetTaxAddress());
        }
    }, [addressTypeSelected]);

    const handleAddressTypeSelectedChange = type => {
        SetAddressTypeSelected(type);
    };

    const createCardShippingAddress = () => {
        return shippingAddress.map((shippingAddress, index) => {
            return (
                <div key={`address-${index}`} className='address-item white mb-10 pt-10 pb-20 pl-30 pr-20 line'>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap-reverse' }}>
                        <div className='pt-20'>
                            {shippingAddress.isDefault === 'Y' && (
                                <h3 className='badge' style={{ fontSize: 16, backgroundColor: '#165fef' }}>
                                    {`${wording.usermenu.address.shippingAddress.default}`}
                                </h3>
                            )}
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.shippingAddress.name}: `}</strong>
                            </span>
                            <span>{`${shippingAddress.name} ${shippingAddress.lastName}`}</span>
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.shippingAddress.address}: `}</strong>
                            </span>
                            <span className='billing-user-address white'>
                                {`${shippingAddress.address}, ${!shippingAddress || !shippingAddress.subDistrict ? "" : `${shippingAddress.subDistrict}, `}${shippingAddress.district}, ${shippingAddress.province}, ${shippingAddress.zipCode}`}
                            </span>
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.shippingAddress.phone}: `}</strong>
                            </span>
                            <span>{`${shippingAddress.phoneNumber}`}</span>
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                <button
                                    className='btn btn-md btn-light mr-10 mt-10'
                                    onClick={() => dispatch(OpenDialogEditAddress(index, shippingAddress))}>
                                    {wording.usermenu.address.shippingAddress.edit}
                                </button>
                                <button
                                    className='btn btn-md btn-light-red mt-10'
                                    onClick={() => dispatch(OpenDialogConfirmDeleteAddress(index, shippingAddress))}>
                                    {wording.usermenu.address.shippingAddress.delete}
                                </button>
                            </div>
                            {shippingAddress.isDefault === 'N' && (
                                <div
                                    className='mt-10'
                                    style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <button
                                        className='btn btn-md btn-color'
                                        onClick={() => dispatch(SetAddresAsDefault(index))}>
                                        {wording.usermenu.address.shippingAddress.setdefault}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        });
    };

    const createCardTaxInvoiceAddress = () => {
        return taxInvoiceAddress.map((taxInvoiceAddress, index) => {
            return (
                <div key={`tax-address-${index}`} className='address-item white mb-10 pt-10 pb-20 pl-30 pr-20 line'>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap-reverse' }}>
                        <div className='pt-20'>
                            {taxInvoiceAddress.isDefault === 'Y' && (
                                <h3 className='badge' style={{ fontSize: 16, backgroundColor: '#165fef' }}>
                                    {`${wording.usermenu.address.taxInvoiceAddress.default}`}
                                </h3>
                            )}
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.taxInvoiceAddress.name}: `}</strong>
                            </span>
                            <span>{`${taxInvoiceAddress.name} ${taxInvoiceAddress.lastName}`}</span>
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.taxInvoiceAddress.taxId}: `}</strong>
                            </span>
                            <span>{hideTaxId(`${taxInvoiceAddress.taxId}`)}</span>
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.taxInvoiceAddress.address}: `}</strong>
                            </span>
                            <span className='billing-user-address white'>
                                {` ${taxInvoiceAddress.address}, ${(!taxInvoiceAddress || !taxInvoiceAddress.subDistrict ? "" : `${taxInvoiceAddress.subDistrict}, `)}${taxInvoiceAddress.district}, ${taxInvoiceAddress.province}, ${taxInvoiceAddress.zipCode}`}
                            </span>
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.taxInvoiceAddress.phone}: `}</strong>
                            </span>
                            <span>{`${taxInvoiceAddress.phoneNumber}`}</span>
                            <br />
                            <span>
                                <strong>{`${wording.usermenu.address.taxInvoiceAddress.email}: `}</strong>
                            </span>
                            <span>{`${taxInvoiceAddress.email}`}</span>
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                <button
                                    className='btn btn-md btn-light mr-10 mt-10'
                                    onClick={() => dispatch(OpenDialogEditTaxAddress(index, taxInvoiceAddress))}>
                                    {wording.usermenu.address.taxInvoiceAddress.edit}
                                </button>
                                <button
                                    className='btn btn-md btn-light-red mt-10'
                                    onClick={() =>
                                        dispatch(OpenDialogConfirmDeleteTaxAddress(index, taxInvoiceAddress))
                                    }>
                                    {wording.usermenu.address.taxInvoiceAddress.delete}
                                </button>
                            </div>
                            {taxInvoiceAddress.isDefault === 'N' && (
                                <div
                                    className='mt-10'
                                    style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <button
                                        className='btn btn-md btn-color'
                                        onClick={() => dispatch(SetTaxAddressAsDefault(index))}>
                                        {wording.usermenu.address.taxInvoiceAddress.setdefault}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        });
    };

    if (shippingAddressFetching || taxInvoiceAddressFetching) {
        return <LayoutPreload />;
    }

    return (
        <div className='main-wrapper shop oh'>
            <DialogCreateAddress />
            <DialogEditAddress />
            <DialogConfirmDeleteAddress />
            <DialogNotAllowDeleteAddress />
            <DialogCreateTaxAddress />
            <DialogEditTaxAddress />
            <DialogConfirmDeleteTaxAddress />
            <DialogNotAllowDeleteTaxAddress />
            <UserTitle title={wording.usermenu.address.myAddress} />
            <section className='section-wrap pt-70 pb-40 catalogue'>
                <div className='container relative'>
                    <div className='row'>
                        <aside className='col-sm-12 col-md-3 sidebar'>
                            <UserSideMenu />
                        </aside>
                        <div className='col-sm-12 col-md-9 catalogue-col mb-50'>
                            <div className='mb-20'>
                                <ul className='nav nav-pills nav-justified list-filter-user'>
                                    <li
                                        role='presentation'
                                        className={addressTypeSelected === shipping ? 'active' : null}>
                                        <a
                                            className='pointer'
                                            onClick={() => handleAddressTypeSelectedChange(shipping)}>
                                            {wording.usermenu.address.shippingAddress.title}
                                        </a>
                                    </li>
                                    <li
                                        role='presentation'
                                        className={addressTypeSelected === taxinvoice ? 'active' : null}>
                                        <a
                                            className='pointer'
                                            onClick={() => handleAddressTypeSelectedChange(taxinvoice)}>
                                            {wording.usermenu.address.taxInvoiceAddress.title}
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {addressTypeSelected === shipping && shippingAddress && shippingAddress.length === 0 && (
                                <NotHaveShippingAddress />
                            )}

                            {addressTypeSelected === shipping && shippingAddress && shippingAddress.length > 0 && (
                                <div className='row items-grid'>
                                    <div className='content-warpper col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                                        <div className='row'>
                                            <div className='address-header col-md-12 pt-10 pb-20 pr-20 line'>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'flex-end'
                                                    }}>
                                                    <button
                                                        className='btn btn-md btn-light'
                                                        onClick={() => dispatch(OpenDialogCreateAddress())}>
                                                        {wording.usermenu.address.shippingAddress.add}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='address-body col-md-12 mt-20'>
                                                {createCardShippingAddress()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {addressTypeSelected === taxinvoice &&
                                taxInvoiceAddress &&
                                taxInvoiceAddress.length === 0 && <NotHaveTaxInvoiceAddress />}

                            {addressTypeSelected === taxinvoice && taxInvoiceAddress && taxInvoiceAddress.length > 0 && (
                                <div className='row items-grid'>
                                    <div className='content-warpper col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                                        <div className='row'>
                                            <div className='address-header col-md-12 pt-10 pb-20 pr-20 line'>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'flex-end'
                                                    }}>
                                                    <button
                                                        className='btn btn-md btn-light'
                                                        onClick={() => dispatch(OpenDialogCreateTaxAddress())}>
                                                        {wording.usermenu.address.taxInvoiceAddress.add}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='address-body col-md-12 mt-20'>
                                                {createCardTaxInvoiceAddress()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
